


























import { defineComponent } from "@vue/composition-api";
import { Message } from "@scrile/api-provider/dist/api/MessagesProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import useAuthUser from "@/hooks/useAuthUser";
import { getElement } from "@/lib/elementHelpers";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";
import BaseConfirm from "@/components/BaseConfirm";
import BaseIcon from "@/components/BaseIcon";
import BaseInputBox from "@/components/BaseInputBox";
import BaseSendMessage from "@/components/BaseSendMessage";
import SendMessageController from "@/components/SendMessageController";

export default defineComponent({
  name: "FeedReaction",
  components: { BaseConfirm, BaseSendMessage, BaseInputBox, BaseIcon, SendMessageController },
  props: {
    contentFeed: { type: Object as () => ContentFeed, required: true },
    show: { type: Boolean, default: false },
  },
  setup() {
    const { authUser } = useAuthUser();
    return {
      authUser,
    };
  },
  data() {
    return {
      value: "",
      focused: false,
    };
  },
  computed: {
    hasText(): boolean {
      return this.value.trim().length > 0;
    },
  },
  methods: {
    async onMessageSend(promise: Promise<Message[]>) {
      const messages = await promise;
      if (messages.length > 0) {
        const notification: NotificationData = {
          text: $t("Comment sent"),
          timeout: 2000,
          onNotificationClick: () =>
            this.$router.push({ name: "messages", params: { userId: this.contentFeed.userId } }),
        };
        this.value = "";
        this.$emit("close");
        emitter.emit(EVENTS.NOTIFICATION_SHOW, notification);
      }
    },
    async onFocus() {
      this.focused = true;
      await this.$nextTick();
      const txtArea = getElement(this.$el).querySelector("textarea");
      txtArea && txtArea.focus();

      if (!this.authUser) {
        this.focused = false;
        emitter.emit(EVENTS.SHOW_LOGIN_SIGNUP_MODAL);
      }
    },
  },
});
